export default "__VITE_ASSET__BIyZjzIC__"